import { useEffect, useState } from "react";
import { trackEvent } from "@/lib/analytics";
import { buildWhatsAppUrl } from "@/lib/utm";

const WhatsAppIcon = () => (
  <svg
    viewBox="0 0 32 32"
    width="28"
    height="28"
    aria-hidden="true"
    fill="currentColor"
  >
    <path d="M19.11 17.32c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.5-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.49 1.07 2.89 1.22 3.09c.15.2 2.1 3.21 5.08 4.5.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35zM16.03 26.34h-.01c-1.9 0-3.77-.51-5.4-1.48l-.39-.23-4.02 1.05 1.07-3.92-.25-.4c-1.06-1.69-1.62-3.64-1.62-5.65 0-5.85 4.76-10.6 10.62-10.6 2.83 0 5.5 1.1 7.5 3.11 2 2 3.11 4.67 3.11 7.5-.01 5.86-4.77 10.62-10.61 10.62zM27.06 4.94A15.42 15.42 0 0016.03 0C7.34 0 .28 7.06.28 15.75c0 2.78.73 5.49 2.11 7.87L.15 32l8.61-2.26a15.7 15.7 0 007.27 1.85h.01c8.68 0 15.75-7.06 15.75-15.75 0-4.21-1.64-8.16-4.73-11.13z" />
  </svg>
);

export const WhatsAppFab = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 800);
    return () => clearTimeout(t);
  }, []);

  return (
    <a
      href={buildWhatsAppUrl()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Написать в WhatsApp"
      data-testid="whatsapp-fab"
      onClick={(e) => {
        e.currentTarget.href = buildWhatsAppUrl();
        trackEvent("whatsapp_click", { location: "fab" });
      }}
      className={`fixed z-[70] bottom-5 right-5 md:bottom-24 md:right-8 flex items-center justify-center rounded-full shadow-2xl transition-all duration-500 ${
        mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      }`}
      style={{
        width: 60,
        height: 60,
        background: "#25D366",
        color: "white",
        boxShadow:
          "0 10px 30px rgba(37,211,102,0.45), 0 4px 12px rgba(0,0,0,0.25)",
      }}
    >
      <span
        className="absolute inset-0 rounded-full"
        style={{
          background: "#25D366",
          animation: "wa-pulse 2.2s ease-out infinite",
          opacity: 0.55,
        }}
      />
      <span className="relative flex items-center justify-center">
        <WhatsAppIcon />
      </span>
      <style>{`
        @keyframes wa-pulse {
          0% { transform: scale(1); opacity: 0.55; }
          70% { transform: scale(1.8); opacity: 0; }
          100% { transform: scale(1.8); opacity: 0; }
        }
      `}</style>
    </a>
  );
};
